export const GET_ORGANIGRAMMA = 'GET_ORGANIGRAMMA';

/**
 * Get organigramma.
 * @function getOrganigramma
 * @param {Object} data Data.
 * @returns {Object} Get organigramma results action.
 */
export function getOrganigramma(path, data, subrequest, page) {
  return {
    type: GET_ORGANIGRAMMA,
    path,
    request: {
      op: 'get',
      path: `${path}/@getOrgChart`,
    },
  };
}
